export enum PDFRendererLanguage {
  ENGLISH = "en",
  TURKISH = "tr",
}

export enum QuestionTypeEnum {
  TF = "TF",
  TEST = "TEST",
  OE = "OE",
  FB = "FB",
  // MATCH = "MATCH",
}
